import { useQuery, UseQueryResult } from "react-query";
import axios from "axios";
import Config from "../config/auth.json";

const fetchDownloadUrl = async (s3Key: string): Promise<string> => {
  const token = JSON.parse(window.localStorage.getItem("okta-token-storage") || "{}")?.accessToken?.accessToken;
  const response = await axios.get(`${Config.endpoint}contractsservice/contracts/download`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { key: s3Key },
  });
  return response.data as string;
};

export const useGetContractDownload = (s3Key: string | null): UseQueryResult<string> => {
  return useQuery(
    ["contract-download", s3Key],
    () => fetchDownloadUrl(s3Key!),
    {
      enabled: false,
      retry: false,
    },
  );
};
